import { ImageLoader } from '../../../ImageLoader';
import { useLocale } from '../../../../i18n/locale';
import { getImageAssetWithLocale, imageKeys } from './imageAssets';
import { ChapterHeadline } from '../chapterComponents/ChapterHeadline';
import { ChapterText } from '../chapterComponents/ChapterText';
import { useCustomIntl } from '../../../../i18n/i18n';

export const ServicesWashingChapter = () => {
  const { locale } = useLocale();
  const { formatMessage } = useCustomIntl();

  const headlineImage = getImageAssetWithLocale(
    imageKeys.servicesWashing,
    locale,
  );

  return (
    <div>
      <div className={'row col-xs-12'}>
        <ChapterHeadline
          messageId={'userManual.chapter.services.washing.headline'}
        />
        <div
          className={
            'display-flex col-xs-12 gap-25 flex-column flex-row-md padding-0'
          }
        >
          <ChapterText
            colSize={12}
            colSizeMd={6}
            messageId={'userManual.chapter.services.washing.text'}
          />
          <div className="col-xs-12 col-md-6 margin-bottom-25">
            <ImageLoader
              src={headlineImage}
              className={'border'}
              alt={formatMessage({
                id: 'userManual.chapter.services.washing.headline',
              })}
              enlargeable
            />
          </div>
        </div>
      </div>
    </div>
  );
};
